<template>

    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <h2>Contact Us</h2>
        <p>
            We welcome your comments and suggestions and love to hear from visitors!
        </p>

        <b-form :novalidate='true' @submit="onSubmit">
            <b-form-group id="emailInputGroup" :class="{ 'is-invalid': formSubmitAttempted && !isValidEmail()}">
                <b-form-input id="emailInput" type="email" v-model="form.email" required placeholder="Your email address" :class="{ 'is-invalid': formSubmitAttempted && !isValidEmail()}">
                </b-form-input>
                <b-form-invalid-feedback id="emailInputFeedback">
                    Enter a valid email address containing an @ symbol
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group id="messageInputGroup">
                <b-form-textarea id="message" v-model="form.message" required placeholder="Message to us" :class="{ 'is-invalid': formSubmitAttempted && !isValidMessage()}">
                </b-form-textarea>
                <b-form-invalid-feedback style='height: 10rem' id="messageInputFeedback">
                    Enter your message to us
                </b-form-invalid-feedback>
            </b-form-group>
            <b-button type="submit" variant="primary" title='Contact Us'>Contact Us</b-button>
        </b-form>

        <div class='top-padding' v-if='messageSent'>
            Your message was sent and we will reply as quickly as we can.  Thank you for contacting us!
        </div>

        <div class='top-padding'>
            <h2>Postal Address</h2>
            <div style='display: inline-block; vertical-align: top'>
                <img :src='this.getSiteImageUrl("AirmailStamp.png")' />
            </div>
            <div style='display: inline-block; vertical-align: top'>
                Handweaving.net<br /> P.O. Box 1158<br /> Coupeville, WA&nbsp;&nbsp;98239<br /> U.S.A.
                <br />
            </div>
        </div>
    </b-container>
</template>

<script>
import mediaService from '../mixins/mediaService.js'
import utilityService from '../mixins/utilityService.js'
import dataService from '../mixins/dataService.js'

export default {
    mixins: [mediaService, utilityService, dataService],
    data: function() {
        return {
            form: {
                email: '',
                message: ''
            },
            formSubmitAttempted: false,
            messageSent: false
        }
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault()
            this.formSubmitAttempted = true
            if (!this.entireFormValid()) {
                return false
            }
            this.contactUs(this.form.email, this.form.message).then(resp => {
                this.messageSent = true
            })
        },

        isValidEmail: function() {
            return this.isValidEmailAddress(this.form.email)
        },

        isValidMessage: function() {
            let message = this.form.message.trim()
            if (message === null) {
                return false
            }
            if (message.length < 2) {
                return false
            }
            return true
        },
        entireFormValid: function() {
            return this.isValidEmail() && this.isValidMessage()
        }
    },
    created() {
        this.$store.commit('setPageTitle', 'Help')
        if (this.$store.getters.isAuthenticated) {
            this.form.email = this.$store.state.authUser.Email
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue